export const TRADE_SESSION_PUBLISH_ENTRY_PAGE_PATH =
  '/tradeSession/publish/entry'

export const TRADE_SESSION_PUBLISH_RESULT_PAGE_PATH =
  '/tradeSession/publish/result'
